import { NextPage } from 'next'
import Head from 'next/head'

import Page from '@components/page'
import PricingModule from '@components/undock/modules/pricing'
import UpsellModule from '@components/undock/modules/upsell'
import { themesMap } from '@components/undock/modules'

const PricingPage: NextPage = () => {
  return (
    <Page lightHeader>
      <Head>
        <title>Undock | Pricing</title>
      </Head>

      <PricingModule
        headline="Upgrade Your Calendar"
        id="pricing"
        subHeadline="Choose the membership that's right for you"
        themeName="light"
        type="upsellModule"
      />
      <UpsellModule
        ctaType="SIGN_UP"
        headline="Make time for what matters"
        id="upsell"
        themeName="dark"
        type="upsellModule"
      />
    </Page>
  )
}

export default PricingPage
